// npm
import axios from 'axios';
import { log } from '@/utils/axios';
import Cookies from 'js-cookie';
import { Message, Spin } from 'iview';
// router
import router from '@/router';

import {
  START_CHECKOUT_REQUEST,
  FINISH_CHECKOUT_REQUEST,
  UPDATE_CARPROFILE_ACTION,
  GET_CARPROFILE_ACTION,
  SET_CARPROFILE,
  SET_MOTORPROFILE,
  UPDATE_INSUINFO_ACTION,
  UPDATE_INSUPERIOD_ACTION,
  SET_INSUINFOS,
  UPDATE_CHECKOUT_INFO_OFCAR_ACTION,
  UPDATE_CHECKOUT_INFO_OFTRAVEL_ACTION,
  UPDATE_CHECKOUT_INFO_OFACCIDENT_ACTION,
  UPDATE_CHECKOUT_INFO_OFPET_ACTION,
  UPDATE_CHECKOUT_INFO_OFVACCINE_ACTION,  //20210530 Wen Add
  SET_CAR_CHECKOUT_INFO,
  SET_MOTOR_CHECKOUT_INFO,
  SET_TRAVEL_CHECKOUT_INFO,
  SET_ACCIDENT_CHECKOUT_INFO,
  SET_PET_CHECKOUT_INFO,
  SET_VACCINE_CHECKOUT_INFO,//20210530 Wen Add
  GET_CHECKOUT_QUOTE_OFCAR_ACTION,
  SET_CHECKOUT_QUOTE_OFCAR,
  GET_CHECKOUT_QUOTE_OFTRAVEL_ACTION,
  SET_CHECKOUT_QUOTE_OFTRAVEL,  
  GET_CHECKOUT_QUOTE_OFACCIDENT_ACTION,
  SET_CHECKOUT_QUOTE_OFACCIDENT,
  GET_CHECKOUT_QUOTE_OFPET_ACTION,
  SET_CHECKOUT_QUOTE_OFPET,
  GET_CHECKOUT_QUOTE_OFVACCINE_ACTION,//20210530 Wen Add
  SET_CHECKOUT_QUOTE_OFVACCINE,//20210530 Wen Add
  CHECKOUT_PAYMENT_ACTION,
  SET_INSUPERIOD
} from "./constants";

const { NODE_ENV } = process.env;
const baseURL = NODE_ENV === 'development'
  ? 'https://localhost:5000/api/'
  : 'https://ec.rockgp.com:5001/api/';
const ajax = axios.create({ baseURL });

Message.config({
  duration: 15
});

const updateCarProfile = async ({ commit }, { vehicleKind, inceptionDateData, carProfileData, insuId }) => {
  commit(START_CHECKOUT_REQUEST);
  //console.log("12345677-insuId:"+insuId);
  const token = Cookies.get('accessToken');
  const data = {
    vehicleKind,
    inceptionDate: inceptionDateData,
    carProfile: carProfileData,
    insuId   
 
  }
  const config = {
    method: 'post',
    url: 'VehicleInsurance/SetCacheUserVehicleData',
    data,
    headers: { Authorization: token }
  };
  try {
    const res = await ajax(config);
    const { success, message, result } = res.data;
    if (!success) {
      commit(FINISH_CHECKOUT_REQUEST);
      Message.warning({
        content: `${message}`,
        closable: true
      });
      return success;
    }
    let checkoutCarData = {
      source: 'checkout',
      profile: { ...carProfileData }
    }
    switch (vehicleKind) {
      case 'C':
        await commit(SET_CARPROFILE, checkoutCarData);
        break;
      case 'M':
        await commit(SET_MOTORPROFILE, checkoutCarData);
        break;
    }
    commit(FINISH_CHECKOUT_REQUEST);
  }
  catch (err) {
    commit(FINISH_CHECKOUT_REQUEST);
    console.log(err);
  }
};
const getCarProfile = async ({ commit }, { vehicleKind,insuId , carProfileData,inceptionDateData}) => {
  commit(START_CHECKOUT_REQUEST);

  const token = Cookies.get('accessToken');
  const data = {
    vehicleKind,
    insuId,
    carProfile: carProfileData,
    inceptionDate: inceptionDateData,
  }
  //console.log("checkout:"+JSON.stringify(inceptionDateData));  
  const config = {
    method: 'post',
    url: 'VehicleInsurance/GetCacheUserVehicleData',
    data,
    headers: { Authorization: token }
  };
  try {
    //console.log("checkout-config");
    const res = await ajax(config);
    const { success, message, result } = res.data;
//console.log("checkout-success");
    if (!success) {
      commit(FINISH_CHECKOUT_REQUEST);
      return true;
    }
    let checkoutCarData = {
      source: 'checkout',
      profile: { ...result },
      inceptionDate:{...result}
    }
    //console.log("checkout-vehicleKind:"+JSON.stringify(checkoutCarData));
    //console.log("checkout-vehicleKind123456:"+JSON.stringify(checkoutCarData.inceptionDate));
    switch (vehicleKind) {
      case 'C':
        await commit(SET_CARPROFILE, checkoutCarData);
        break;
      case 'M':
        await commit(SET_MOTORPROFILE, checkoutCarData);
        break;
    }
    //console.log("checkout-true");
    return true;
    commit(FINISH_CHECKOUT_REQUEST);
  }
  catch (err) {
    commit(FINISH_CHECKOUT_REQUEST);
    console.log(err);
  }
}
const updateInsuperiod = async ({ commit }, payload) => {
  commit(START_CHECKOUT_REQUEST);
  commit(SET_INSUPERIOD, payload);
  commit(FINISH_CHECKOUT_REQUEST);
};
const updateInsuInfo = async ({ commit }, payload) => {
  commit(START_CHECKOUT_REQUEST);
  commit(SET_INSUINFOS, payload);
  commit(FINISH_CHECKOUT_REQUEST);
};
const updateCheckoutInfoOfCar = async ({ commit }, payload) => {
  const { insuType, insuInfo, inceptionDateData, userProfileFormData, autoNoticeFormData, carProfileData } = payload;
  const checkoutInfo = {
    insuInfos: [...insuInfo],
    inceptionDate: { ...inceptionDateData },
    autoNoticeData: { ...autoNoticeFormData },
    userProfile: {
      ...userProfileFormData
    },
    carProfile: { ...carProfileData }
  };
  commit(START_CHECKOUT_REQUEST);
  switch (insuType) {
    case 'car':
      commit(SET_CAR_CHECKOUT_INFO, checkoutInfo);
      break;
    case 'motor':
      commit(SET_MOTOR_CHECKOUT_INFO, checkoutInfo);
      break;
  }

  //console.log("checkout-vehicleKind33:"+JSON.stringify(checkoutInfo));
  commit(FINISH_CHECKOUT_REQUEST);
};
const updateCheckoutInfoOfTravel = async ({ commit }, payload) => {
  const { insuType, insuInfo, travelFilterFormData, userProfileFormData, travelNoticeFormData, beneficiaryProfileFormData } = payload;
  const checkoutInfo = {
    insuInfos: [...insuInfo],
    travelFilter: { ...travelFilterFormData },
    travelNoticeData: { ...travelNoticeFormData },
    beneficiaryProfile: { ...beneficiaryProfileFormData },
    userProfile: { ...userProfileFormData }
  };
  commit(START_CHECKOUT_REQUEST);
  commit(SET_TRAVEL_CHECKOUT_INFO, checkoutInfo);
  commit(FINISH_CHECKOUT_REQUEST);
};
const updateCheckoutInfoOfAccident = async ({ commit }, payload) => {
  const { insuType, insuInfo, accidentFilterFormData, userProfileFormData, accidentNoticeFormData, beneficiaryProfileFormData,healthNoticeFormData } = payload;
  const checkoutInfo = {
    insuInfos: [...insuInfo],
    accidentFilter: { ...accidentFilterFormData },
    accidentNoticeData: { ...accidentNoticeFormData },
    accidentbeneficiaryProfile: { ...beneficiaryProfileFormData },
    userProfile: { ...userProfileFormData },
    healthNoticeData:{...healthNoticeFormData}
  };

//console.log("updateCheckoutInfoOfAccident+++"+JSON.stringify(checkoutInfo))

  commit(START_CHECKOUT_REQUEST);
  commit(SET_ACCIDENT_CHECKOUT_INFO, checkoutInfo);
  commit(FINISH_CHECKOUT_REQUEST);
};

const updateCheckoutInfoOfPet = async ({ commit }, payload) => {
  const { insuType, insuInfo, petFilterFormData, userProfileFormData, petNoticeFormData, petHealthNoticeFormData } = payload;
  const checkoutInfo = {
    insuInfos: [...insuInfo],
    petFilter: { ...petFilterFormData },
    petNoticeData: { ...petNoticeFormData },
    //petBeneficiaryProfile: { ...beneficiaryProfileFormData },
    userProfile: { ...userProfileFormData },
    petHealthNoticeData:{...petHealthNoticeFormData}
  };
  commit(START_CHECKOUT_REQUEST);
  commit(SET_PET_CHECKOUT_INFO, checkoutInfo);
  commit(FINISH_CHECKOUT_REQUEST);
};

const updateCheckoutInfoOfVaccine = async ({ commit }, payload) => {  //20210530 Wen Add
  const { insuType, insuInfo, vaccineFilterFormData, userProfileFormData, vaccineNoticeFormData, beneficiaryProfileFormData} = payload;//,insurBeneficiaryProfileFormDate,healthNoticeFormData 
  const checkoutInfo = {
    insuInfos: [...insuInfo],
    vaccineFilter: { ...vaccineFilterFormData },
    vaccineNoticeData: { ...vaccineNoticeFormData },
    vaccineBeneficiaryProfile: { ...beneficiaryProfileFormData },
    userProfile: { ...userProfileFormData },
    //vaccineHealthNoticeData:{...healthNoticeFormData},
    //insurBeneficiaryProfileFormDate:{...insurBeneficiaryProfileFormDate}
  };
  commit(START_CHECKOUT_REQUEST);
  commit(SET_VACCINE_CHECKOUT_INFO, checkoutInfo);
  commit(FINISH_CHECKOUT_REQUEST);
};

const getCheckoutQuoteOfCar = async ({ commit }, payload) => {
  commit(START_CHECKOUT_REQUEST);
  const token = Cookies.get('accessToken');
  const { insuInfo, inceptionDateData, userProfileFormData, autoNoticeFormData, carProfileData } = payload;
  const { mail, address, isEBill } = userProfileFormData; 
  const data = {
    insuInfo: {
      insuId: insuInfo.map(info => info.insuId)
    },
    inceptionDate: { ...inceptionDateData },
    userProfile: {
      mail,
      address: {
        ...address
      },
      isEBill,
    },
    autoNoticeData: { ...autoNoticeFormData },
    carProfile: {
      ...carProfileData,
      carLicenseDate: {
        ...carProfileData.carLicenseDate,
        year: (parseInt(carProfileData.carLicenseDate.year) + 1911).toString()
      }
    }
  }
  //console.log("autoNoticeData-action-data:"+JSON.stringify(data.autoNoticeData));
  const config = {
    method: 'post',
    url: 'VehicleInsurance/CalPremium',
    data,
    headers: { Authorization: token }
  };
  try {
    const res = await ajax(config);
    const { success, message, result } = res.data;
    const nowPathName = window.location.pathname;
    if (!nowPathName.match('checkout')) {
      return success;
    }
    if (!success) {
      commit(FINISH_CHECKOUT_REQUEST);
      Message.warning({
        content: `${message}`,
        closable: true
      });
      return success;
    }
    const { quotes, carInfo } = result;
    commit(SET_CHECKOUT_QUOTE_OFCAR, { quotes, carInfo });
    commit(FINISH_CHECKOUT_REQUEST);
    return success;
  }
  catch (err) {
    console.log(err);
    commit(FINISH_CHECKOUT_REQUEST);
    Message.warning({
      content: `很抱歉，目前系統繁忙中，請稍後再試，謝謝您。`,
      closable: true
    });
    return success;
  }
};
const getCheckoutQuoteOfTravel = async ({ commit }, payload) => {
  commit(START_CHECKOUT_REQUEST);
  const token = Cookies.get('accessToken');
  const { insuInfo, travelFilterFormData, userProfileFormData, travelNoticeFormData, beneficiaryProfileFormData } = payload;
  const { mail, address, isEBill, isGuardianship } = userProfileFormData;
  const data = {
    insuInfo: {
      insuId: insuInfo.map(info => info.insuId)
    },
    travelFilter: {
      ...travelFilterFormData,
      travelArea: travelFilterFormData.travelArea.map(area => area.country)
    },
    userProfile: {
      mail,
      address: {
        ...address
      },
      isEBill,
      isGuardianship
    },
    travelNoticeData: { ...travelNoticeFormData },
    beneficiaryProfile: { ...beneficiaryProfileFormData }
  }
  const config = {
    method: 'post',
    url: 'TravelAcidentInsurance/CalPremium',
    data,
    headers: { Authorization: token }
  };
  try {
    const res = await ajax(config);
    const { success, message, result } = res.data;
    const nowPathName = window.location.pathname;
    if (!nowPathName.match('checkout')) {
      return success;
    }
    let msg;
    if (!success) {
      commit(FINISH_CHECKOUT_REQUEST);
      if (message.match('乘載噸數跟車種不合') || message.match('此「車種代碼」和「廠牌型式代碼」不符')) {
        msg = '請確認汽車車種、排氣量、乘客數與行照相符，請重新嘗試一次。'
      } else {
        msg = '很抱歉，目前系統繁忙中，請稍後再試，謝謝您。'
      }
      Message.warning({
        content: `${msg}`,
        closable: true
      });
      return success;
    }
    const { quotes, travelInsuInfo } = result;
    commit(SET_CHECKOUT_QUOTE_OFTRAVEL, { quotes, travelInsuInfo });
    commit(FINISH_CHECKOUT_REQUEST);
    return success;
  }
  catch (err) {
    console.log(err);
    commit(FINISH_CHECKOUT_REQUEST);
    Message.warning({
      content: `很抱歉，目前系統繁忙中，請稍後再試，謝謝您。`,
      closable: true
    });
    return success;
  }
};
const getCheckoutQuoteOfAccident = async ({ commit }, payload) => {
  commit(START_CHECKOUT_REQUEST);
  const token = Cookies.get('accessToken');
  const { insuInfo, accidentFilterFormData, userProfileFormData, accidentNoticeFormData, beneficiaryProfileFormData, healthNoticeFormData } = payload;
  const { mail, address, isEBill, isGuardianship } = userProfileFormData;
  const data = {
    insuInfo: {
      insuId: insuInfo.map(info => info.insuId)
    },
    accidentFilter: {
      ...accidentFilterFormData,
      //accidentArea: accidentFilterFormData.accidentArea,      
     // otherjob  //20201229 Wen Add
    },
    userProfile: {
      mail,
      address: {
        ...address
      },
      isEBill,
      isGuardianship
    },
    accidentNoticeData: { ...accidentNoticeFormData },
    accidentbeneficiaryProfile: { ...beneficiaryProfileFormData },
    healthNoticeData:{...healthNoticeFormData}
  }

  //console.log("getCheckoutQuoteOfPet+++"+JSON.stringify(data));
  const config = {
    method: 'post',
    url: 'AccidentInsurance/CalPremium',
    data,
    headers: { Authorization: token }
  };
  try {
    const res = await ajax(config);
    const { success, message, result } = res.data;
    //console.log("data"+JSON.stringify(data));
    //console.log("result"+JSON.stringify(result));
    const nowPathName = window.location.pathname;
    if (!nowPathName.match('checkout')) {
      return success;
    }
    let msg;
    if (!success) {
      commit(FINISH_CHECKOUT_REQUEST);
      /*if (message.match('乘載噸數跟車種不合') || message.match('此「車種代碼」和「廠牌型式代碼」不符')) {
        msg = '請確認汽車車種、排氣量、乘客數與行照相符，請重新嘗試一次。'
      } else {*/
        msg = '很抱歉，目前系統繁忙中，請稍後再試，謝謝您。'
     // }
      Message.warning({
        content: `${msg}`,
        closable: true
      });
      return success;
    }
    const { quotes, accidentInsuInfo } = result;
    //console.log("quotes--"+JSON.stringify(quotes));
    //console.log("accidentInsuInfo--"+JSON.stringify(accidentInsuInfo));
    //console.log("result--"+JSON.stringify(result));
    commit(SET_CHECKOUT_QUOTE_OFACCIDENT, { quotes, accidentInsuInfo });  //isbuy
    commit(FINISH_CHECKOUT_REQUEST);
    return success;
  }
  catch (err) {
    console.log(err);
    commit(FINISH_CHECKOUT_REQUEST);
    Message.warning({
      content: `很抱歉，目前系統繁忙中，請稍後再試，謝謝您。`,
      closable: true
    });
    return success;
  }
};

const getCheckoutQuoteOfPet = async ({ commit }, payload) => {
  commit(START_CHECKOUT_REQUEST);
  const token = Cookies.get('accessToken');
  const { insuInfo, petFilterFormData, userProfileFormData, petNoticeFormData, beneficiaryProfileFormData, petHealthNoticeFormData } = payload;
  const { mail, address, isEBill, isGuardianship } = userProfileFormData;
  const data = {
    insuInfo: {
      insuId: insuInfo.map(info => info.insuId)
    },
    petFilter: {
      ...petFilterFormData,
      //accidentArea: accidentFilterFormData.accidentArea,      
     // otherjob  //20201229 Wen Add
    },
    userProfile: {
      mail,
      address: {
        ...address
      },
      isEBill,
      isGuardianship
    },
    petNoticeData: { ...petNoticeFormData },
    //petBeneficiaryProfile: { ...beneficiaryProfileFormData },
    petHealthNoticeData:{...petHealthNoticeFormData}
  }

  const config = {
    method: 'post',
    url: 'PetInsurance/CalPremium',
    data,
    headers: { Authorization: token }
  };
  try {
    //console.log("data++"+JSON.stringify(data));
    const res = await ajax(config);    
    const { success, message, result } = res.data;
    //console.log("result"+JSON.stringify(result));
    const nowPathName = window.location.pathname;
    if (!nowPathName.match('checkout')) {
      return success;
    }
    let msg;
    if (!success) {
      commit(FINISH_CHECKOUT_REQUEST);
      /*if (message.match('乘載噸數跟車種不合') || message.match('此「車種代碼」和「廠牌型式代碼」不符')) {
        msg = '請確認汽車車種、排氣量、乘客數與行照相符，請重新嘗試一次。'
      } else {*/
       // msg = '很抱歉，目前系統繁忙中，請稍後再試，謝謝您。'
     // }
      Message.warning({
        content: `${message}`,
        closable: true
      });
      return success;
    }
    const { quotes, petInsuInfo } = result;
    commit(SET_CHECKOUT_QUOTE_OFPET, { quotes, petInsuInfo });  //isbuy
    commit(FINISH_CHECKOUT_REQUEST);
    return success;
  }
  catch (err) {
    console.log(err);
    commit(FINISH_CHECKOUT_REQUEST);
    Message.warning({
      content: `很抱歉，目前系統繁忙中，請稍後再試，謝謝您。`,
      closable: true
    });
    return success;
  }
};

const getCheckoutQuoteOfVaccine = async ({ commit }, payload) => {
  commit(START_CHECKOUT_REQUEST);  //20210530 Wen Add
  const token = Cookies.get('accessToken');
  const { insuInfo, vaccineFilterFormData, userProfileFormData, vaccineNoticeFormData, beneficiaryProfileFormData } = payload;//,healthNoticeFormData,insurBeneficiaryProfileFormDate
  const { mail, address, isEBill, isGuardianship } = userProfileFormData;
  const data = {
    insuInfo: {
      insuId: insuInfo.map(info => info.insuId)
    },
    vaccineFilter: {
      ...vaccineFilterFormData,
      //accidentArea: accidentFilterFormData.accidentArea,      
     // otherjob  //20201229 Wen Add
    },
    userProfile: {
      mail,
      address: {
        ...address
      },
      isEBill,
      isGuardianship
    },
    vaccineNoticeData: { ...vaccineNoticeFormData },
    vaccineBeneficiaryProfile: { ...beneficiaryProfileFormData },
   //vaccineHealthNoticeData:{...healthNoticeFormData},
    //insurBeneficiaryProfileFormDate:{...insurBeneficiaryProfileFormDate}
  }
  //console.log("data++++--"+JSON.stringify(data));
  const config = {
    method: 'post',
    url: 'VaccineInsurance/CalPremium',
    data,
    headers: { Authorization: token }
  };
  try {
    const res = await ajax(config);
    const { success, message, result } = res.data;
    //console.log("result"+JSON.stringify(result));
    const nowPathName = window.location.pathname;
    if (!nowPathName.match('checkout')) {
      return success;
    }
    let msg;
    if (!success) {
      commit(FINISH_CHECKOUT_REQUEST);
      /*if (message.match('乘載噸數跟車種不合') || message.match('此「車種代碼」和「廠牌型式代碼」不符')) {
        msg = '請確認汽車車種、排氣量、乘客數與行照相符，請重新嘗試一次。'
      } else {*/
      //  msg = '很抱歉，目前系統繁忙中，請稍後再試，謝謝您。'
     // }
      Message.warning({
        content: `${message}`,
        closable: true
      });
      return success;
    }
    const { quotes, vaccineInsuInfo } = result;
    commit(SET_CHECKOUT_QUOTE_OFVACCINE, { quotes, vaccineInsuInfo });  //isbuy
    commit(FINISH_CHECKOUT_REQUEST);
    return success;
  }
  catch (err) {
    console.log(err);
    commit(FINISH_CHECKOUT_REQUEST);
    Message.warning({
      content: `很抱歉，目前系統繁忙中，請稍後再試，謝謝您。`,
      closable: true
    });
    return success;
  }
};

const checkoutPayment = async ({ commit, rootState }, { insuType, payload }) => {
  commit(START_CHECKOUT_REQUEST);

  const token = Cookies.get('accessToken');
  const channel = Cookies.get('channel') || null;
  const channelCar = Cookies.get('channelCar') || null;
  const { insuIds, basketNum, quotationNum, quotationPrice, creditCard, checkoutInfo, tranNum } = payload;
  let data = {
    channel,
    channelCar,
    insuType,
    insuIds: [...insuIds],
    basketNum,
    tranNum,
    quotationNum,
    quotationPrice,
    creditCard: { ...creditCard },
    checkoutInfo: { ...checkoutInfo }
  }
  let url = '';
  if (insuType === 'travel') {
    data.checkoutInfo = {
      ...checkoutInfo,
      travelFilter: {
        ...checkoutInfo.travelFilter,
        travelArea: checkoutInfo.travelFilter.travelArea.map(area => area.country)
      },      
    }
    url = 'TravelAcidentInsurance/PaymentSubmit';
  }
  else if(insuType === 'accident')
  {
    data.checkoutInfo={
      ...checkoutInfo,
      accidentFilter:{
        ...checkoutInfo.accidentFilter,
        //accidentArea:checkoutInfo.accidentFilter.accidentArea.map(area =>area.jobtype)
      }
    }
    url = 'AccidentInsurance/PaymentSubmit';   
  } 
  else if(insuType === 'pet')
  {
    data.checkoutInfo={
      ...checkoutInfo,
      petFilter:{
        ...checkoutInfo.petFilter,       
      }
    }
    url = 'PetInsurance/PaymentSubmit';   
  } 
  else if(insuType === 'vaccine')
  {
    data.checkoutInfo={
      ...checkoutInfo,
      vaccineFilter:{
        ...checkoutInfo.vaccineFilter,       
      }
    }
    url = 'VaccineInsurance/PaymentSubmit';   
  } 
  else {
    url = 'VehicleInsurance/PaymentSubmit';
  }
  const config = {
    method: 'post',
    url: url,
    data,
    headers: { Authorization: token }
  };
  try {
    const res = await ajax(config);
    const { success, message, result } = res.data;

    if (!success) {
      commit(FINISH_CHECKOUT_REQUEST);
      Message.warning({
        content: `${message}`,
        closable: true
      });
      return success;
    }
    const logPayload = {
      basketId: basketNum,
      webUserIp: rootState.user.ip,
      webControlCodeId: 'PAY',
      webProgramCodeId: 'CKP'
    };
    log(logPayload);
    commit(FINISH_CHECKOUT_REQUEST);
    return success;
  }
  catch (err) {
    console.log(err);
    commit(FINISH_CHECKOUT_REQUEST);
    Message.warning({
      content: `很抱歉，目前系統繁忙中，請稍後再試，謝謝您。`,
      closable: true
    });
  }
};
export default {
  [UPDATE_CARPROFILE_ACTION]: updateCarProfile,
  [GET_CARPROFILE_ACTION]: getCarProfile,
  [UPDATE_INSUPERIOD_ACTION]: updateInsuperiod,
  [UPDATE_INSUINFO_ACTION]: updateInsuInfo,
  [UPDATE_CHECKOUT_INFO_OFCAR_ACTION]: updateCheckoutInfoOfCar,
  [UPDATE_CHECKOUT_INFO_OFTRAVEL_ACTION]: updateCheckoutInfoOfTravel,
  [UPDATE_CHECKOUT_INFO_OFACCIDENT_ACTION]: updateCheckoutInfoOfAccident,
  [UPDATE_CHECKOUT_INFO_OFPET_ACTION]: updateCheckoutInfoOfPet,
  [UPDATE_CHECKOUT_INFO_OFVACCINE_ACTION]: updateCheckoutInfoOfVaccine,
  [GET_CHECKOUT_QUOTE_OFCAR_ACTION]: getCheckoutQuoteOfCar,
  [GET_CHECKOUT_QUOTE_OFTRAVEL_ACTION]: getCheckoutQuoteOfTravel,
  [GET_CHECKOUT_QUOTE_OFACCIDENT_ACTION]: getCheckoutQuoteOfAccident,
  [GET_CHECKOUT_QUOTE_OFPET_ACTION]: getCheckoutQuoteOfPet,
  [GET_CHECKOUT_QUOTE_OFVACCINE_ACTION]:getCheckoutQuoteOfVaccine,
  [CHECKOUT_PAYMENT_ACTION]: checkoutPayment
};